<template>
    <div class="image-carousel slider">
        <div class="container">
            <carousel-3d
                :perspective="20"
                :display="5"
                :space="isPhone ? 120 : 200"
                :width="isPhone ? 256 : 467"
                :height="isPhone ? 324 : 586"
                :border="0"
                :controlsVisible="!isPhone"
                :controlsPrevHtml="'&#8592;'"
                :controlsNextHtml="'&#8594;'"
                @before-slide-change="onBeforeSlideChange"
                ref="carousel">
                <slide :index="0" data-author="Angelika Rosier" data-location="Tampa, Florida, USA">
                    <img
                        src="https://images.iphonephotographyschool.com/31618/467/cave.jpg"
                        srcset="https://images.iphonephotographyschool.com/31618/932/cave.jpg 2x"
                        alt="student photo gap" />
                </slide>
                <slide :index="1" data-author="Chetana Keltcher" data-location="Lexington, Massachusetts, USA">
                    <img
                        src="https://images.iphonephotographyschool.com/31620/467/portrait.png"
                        srcset="https://images.iphonephotographyschool.com/31620/932/portrait.png 2x"
                        alt="student photo portrait" />
                </slide>
                <slide :index="2" data-author="Anastasia Butrym" data-location="Sydney, Australia">
                    <img
                        src="https://images.iphonephotographyschool.com/31617/467/bug.png"
                        srcset="https://images.iphonephotographyschool.com/31617/932/bug.png 2x"
                        alt="student photo beetle" />
                </slide>
                <slide :index="3" data-author="Jurgita Vasilevičienė" data-location="Vilnius, Lithuania">
                    <img
                        src="https://images.iphonephotographyschool.com/31621/467/reflection-building.png"
                        srcset="https://images.iphonephotographyschool.com/31621/932/reflection-building.png 2x"
                        alt="student photo carousel at night" />
                </slide>
                <slide :index="4" data-author="Kristin Dammann Davis" data-location="Murray, Utah, USA">
                    <img
                        src="https://images.iphonephotographyschool.com/31622/467/reflection.jpg"
                        srcset="https://images.iphonephotographyschool.com/31622/932/reflection.jpg 2x"
                        alt="student photo red rocks" />
                </slide>
                <slide :index="5" data-author="Anton Golikov" data-location="Odessa, Ukraine">
                    <img
                        src="https://images.iphonephotographyschool.com/31619/467/child.jpg"
                        srcset="https://images.iphonephotographyschool.com/31619/932/child.jpg 2x"
                        alt="student photo grayscale child" />
                </slide>
            </carousel-3d>

            <div class="container" :class="{ 'direction-rtl text--center': isRTL }">
                <i class="caption text--center"
                    >{{ $t('ipa.photoBy') }} {{ author }}, {{ $t('ipa.member') }} {{ $t('ipa.title') }}
                    {{ $t('ipa.from') }} {{ location }}</i
                >
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel3d, Slide } from '@nanoandrew4/vue3-carousel-3d';
import { helpers } from '../../helpers';

export default {
    components: {
        Carousel3d,
        Slide,
    },
    data() {
        return {
            author: this.$t('ipa.Angelika Rosier'),
            location: this.$t('ipa.Tampa, Florida, USA'),
        };
    },
    computed: {
        isPhone() {
            return helpers.isPhone();
        },
        isRTL() {
            return window.App.isRTL;
        }
    },
    methods: {
        onBeforeSlideChange(index) {
            const authorKey = this.$refs.carousel.$el.children[0].children[index].dataset['author'];
            const locationKey = this.$refs.carousel.$el.children[0].children[index].dataset['location'];
            this.author = this.$t('ipa.' + authorKey);
            this.location = this.$t('ipa.' + locationKey);
        },
    },
};
</script>

<style lang="sass">
.new_sp--ipa
    .image-carousel
        padding: 80px 0
        margin: -80px 0
        overflow: hidden

        .carousel-3d-slider
            margin: 0 auto
            perspective: 0 !important
            transition: all .6s ease-in-out

        &.open
            .carousel-3d-slider
                perspective: 1000px !important

            .carousel-3d-slide
                &.left-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(-30px)

                &.right-1
                    @media screen and (min-width: 568px)
                        img
                            transform: translateX(30px)

        .carousel-3d-container
            margin: 0
            overflow: visible
            // touch-action: none
            cursor: grab

            &:focus
                cursor: grabbing

            .carousel-3d-slide
                background: none
                overflow: visible
                will-change: transform

                img
                    border-radius: 16px
                    box-shadow: 0px 17px 40px 10px rgba(0, 0, 0, 0.15)
                    transform: none !important
                    transition: transform 500ms ease
                    will-change: transform


        .carousel-3d-controls
            @media screen and (min-width: 768px)
                display: none

            @media screen and (min-width: 1366px)
                display: block

            .prev,
            .next
                display: flex
                align-items: center
                justify-content: center
                height: 62px
                width: 62px
                font-size: 28px
                border-radius: 50%
                background: linear-gradient(139.81deg, rgba(235, 237, 254, 0.6) 13.11%, rgba(235, 237, 254, 0.1) 84.95%)
                box-shadow: 4px 4px 21px -1px rgba(0, 0, 0, 0.25)
                backdrop-filter: blur(20px)

                &:hover
                    opacity: 1

            .prev
                left: -30px

            .next
                right: -30px

        .caption
            position: relative
            min-height: 80px

            @media screen and (min-width: 568px)
                min-height: 52px
</style>
